export default __webpack_public_path__ + "static/media/BNB_TINY.e084bd3b.svg";